import React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
import { SectionHeading } from 'components/misc/Headings.js';
import nosotras from '../../images/nosotras-background.png';

const Container = tw.div`relative px-4 sm:px-8 md:px-16 lg:px-24`; // Añadido padding horizontal
const TwoColumn = tw.div`flex flex-col justify-between max-w-screen-xl mx-auto md:py-8 items-center`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)((props) => [
	tw`mt-16 md:mt-0 text-center`,
	props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const TextContent = tw.div`lg:py-8 w-full`;

const Heading = tw(SectionHeading)`mt-4 font-black text-center text-3xl sm:text-4xl lg:text-5xl leading-tight`;
const Image = tw.img`mt-8 mb-8 w-full max-w-2xl mx-auto rounded-lg shadow-lg`;
const Description = tw.p`mt-4 text-center text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

export default ({
	heading = '',
	description = (
		<>
			La Cocina de Emilia nació como un emprendimiento familiar, con la idea de llevar a tu mesa comida casera,
			rica y hecha con amor, como en casa. Creemos en los sabores simples, en la calidad de los ingredientes y en
			esos platos que reconfortan y acompañan el día a día.<br></br>
			Cocinamos de manera artesanal, cuidando cada detalle, para que comer bien sea fácil, accesible y
			disfrutable. Detrás de cada receta hay trabajo, dedicación y muchas ganas de que te sientas a gusto cada vez
			que nos elegís. <br></br>
			Actualmente contamos con dos sucursales, en jacinto vera y en pocitos. <br></br>
			<br></br>
			Gracias por ser parte de este camino y por elegirnos para acompañar tus comidas 💚
		</>
	),
	textOnLeft = true,
}) => {
	return (
		<Container>
			<TwoColumn>
				<TextColumn textOnLeft={textOnLeft}>
					<TextContent>
						<Heading>{heading}</Heading>
						<Image src={nosotras} alt="Nosotras" />
						<Description>{description}</Description>
					</TextContent>
				</TextColumn>
			</TwoColumn>
		</Container>
	);
};
